import { UserStatus } from '@bp/bp-graphql-types';

export const profileHasUser = (status: UserStatus | undefined) => {
  return status === UserStatus.ImpersonateOnly || status === UserStatus.Full || status === UserStatus.Invited;
};
